<!-- Sidebar Overlay -->
<div class="add-supplier-sidebar-overlay"
    [class.show]="isVisible"
    (click)="hide()">
</div>

<!-- Sidebar Panel -->
<div class="add-supplier-sidebar"
    [class.show]="isVisible">

    <!-- Header -->
    <div class="sidebar-header">
        <h4 class="sidebar-title">{{ mode === 'add' ? 'Add Supplier' : 'Update Supplier Rate Card' }}</h4>
        <button type="button"
            class="close-btn"
            (click)="hide()">
            <i class="material-icons-round">close</i>
        </button>
    </div>

    <!-- Body -->
    <div class="sidebar-body">
        <!-- Supplier Name (Only show in add mode) -->
        <div class="form-group"
            *ngIf="mode === 'add'">

            <ng-container *ngIf="!isNewSupplier">
                <label for="supplierSelect">Supplier Name<span class="text-danger">*</span></label>
                <ng-select [(ngModel)]="selectedSupplierId"
                    [items]="suppliers"
                    bindLabel="name"
                    bindValue="id"
                    [loading]="isLoadingSuppliers"
                    [searchable]="true"
                    [clearable]="true"
                    [addTag]="addTagFn"
                    (change)="onSupplierChange($event)"
                    placeholder="Select or Search Supplier"
                    class="pmd-select pmd-select-outline"
                    id="supplierSelect">
                    <ng-template ng-tag-tmp
                        let-search="searchTerm">
                        <div class="d-flex align-items-center">
                            <i class="material-icons-round text-primary me-2">add</i>
                            <span class="text-primary fw-bold">Add "{{search}}" as new Supplier</span>
                        </div>
                    </ng-template>
                </ng-select>
            </ng-container>

            <ng-container *ngIf="isNewSupplier">
                <label>Supplier Name<span class="text-danger">*</span></label>
                <div class="d-flex gap-2 align-items-center mb-3">
                    <input type="text"
                        class="form-control"
                        [(ngModel)]="newSupplierName"
                        (input)="onManualNameChange()"
                        placeholder="Supplier Name">
                    <button class="btn btn-outline-secondary btn-sm cancel-new-supplier-btn"
                        (click)="cancelNewSupplier()">
                        <i class="material-icons-round">close</i>
                    </button>
                </div>

                <div class="form-group mb-3">
                    <label>GST Number</label>
                    <input type="text"
                        class="form-control"
                        [(ngModel)]="gstNumber"
                        (input)="gstDetail()"
                        (blur)="gstDetail()"
                        placeholder="Enter 15-digit GST Number">
                </div>

                <div class="form-group">
                    <label>Supplier Alias</label>
                    <input type="text"
                        class="form-control"
                        [(ngModel)]="supplierAlias"
                        placeholder="Enter Supplier Alias (Optional)">
                </div>

                <div class="form-group mb-3">
                    <label>Mobile Number<span class="text-danger">*</span></label>
                    <input type="tel"
                        class="form-control"
                        [class.is-invalid]="mobileError"
                        [(ngModel)]="mobileNumber"
                        (input)="validateMobile()"
                        (keypress)="onMobileKeyPress($event)"
                        maxlength="10"
                        placeholder="Enter 10-digit Mobile Number">
                    <small class="text-danger"
                        *ngIf="mobileError">{{ mobileError }}</small>
                </div>

                <div class="form-group mb-3">
                    <label>Email</label>
                    <input type="email"
                        class="form-control"
                        [class.is-invalid]="emailError"
                        [(ngModel)]="email"
                        (blur)="validateEmail()"
                        placeholder="Enter Email Address (Optional)">
                    <small class="text-danger"
                        *ngIf="emailError">{{ emailError }}</small>
                </div>
            </ng-container>
        </div>

        <!-- Upload Rate Contract Section -->
        <div class="upload-section">
            <div class="section-header">
                <i class="material-icons-round">file_upload</i>
                <span>Upload Rate Contract in below format</span>
            </div>

            <!-- Sample Rate Contract Download -->
            <div class="sample-contract">
                <div class="file-icon">
                    <i class="material-icons-round">description</i>
                </div>
                <div class="file-info">
                    <div class="file-name">Sample Rate Contract</div>
                    <div class="file-type">XLS File</div>
                </div>
                <button type="button"
                    class="download-btn"
                    (click)="downloadSampleContract()">
                    <i class="material-icons-round">download</i>
                </button>
            </div>

            <!-- Existing Rate Card Info (Only in update mode and if rate card exists) -->
            <div class="existing-rate-card-info"
                *ngIf="mode === 'update' && hasExistingRateCard && !isNewSupplier">
                <div class="info-alert">
                    <i class="material-icons-round">lightbulb</i>
                    <div class="alert-content">
                        <div class="alert-title">Rate Card is already available for this supplier.</div>
                        <div class="alert-subtitle">Upload a new file below to update it.</div>
                    </div>
                </div>

                <div class="existing-file-card">
                    <div class="file-icon">
                        <i class="material-icons-round">description</i>
                    </div>
                    <div class="file-details">
                        <div class="file-name">{{ currentSupplierName }} Rate Card</div>
                        <div class="file-size"
                            *ngIf="!isLoadingExistingRateCard">XLSX File</div>
                        <div class="file-size text-primary fw-bold"
                            *ngIf="isLoadingExistingRateCard">
                            <span class="spinner-border spinner-border-sm me-1"></span>Downloading...
                        </div>
                    </div>
                    <button type="button"
                        class="download-icon-btn"
                        (click)="downloadExistingRateCard()"
                        [disabled]="isLoadingExistingRateCard">
                        <i class="material-icons-round">download</i>
                    </button>
                </div>
            </div>

            <!-- Rate Contract Label -->
            <div class="form-group mt-3">
                <label>Rate Card<span class="text-danger">*</span></label>
            </div>

            <!-- File Upload Area -->
            <div class="upload-area"
                [class.dragging]="isDragging"
                [class.has-file]="rateContractFile"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onFileDrop($event)">

                <ng-container *ngIf="!rateContractFile">
                    <div class="upload-icon">
                        <!-- Using material icon instead of broken SVG image -->
                        <i class="material-icons-round"
                            *ngIf="!isDragging">cloud_upload</i>
                        <i class="material-icons-round text-warning"
                            *ngIf="isDragging">cloud_upload</i>
                    </div>
                    <p>Drag and Drop</p>
                    <span class="divider-text">Or</span>
                    <label for="rateContractFile"
                        class="btn-browse">
                        Browse Files
                        <input type="file"
                            id="rateContractFile"
                            style="display: none;"
                            accept=".xls,.xlsx"
                            (change)="onFileSelected($event)">
                    </label>
                </ng-container>

                <ng-container *ngIf="rateContractFile">
                    <div class="selected-file">
                        <i class="material-icons-round text-success">check_circle</i>
                        <span class="file-name">{{ rateContractFile.name }}</span>
                        <button type="button"
                            class="remove-btn"
                            (click)="removeFile()">
                            <i class="material-icons-round">delete</i>
                        </button>
                    </div>
                </ng-container>
            </div>

            <!-- Supported Formats Info -->
            <div class="upload-info">
                <div class="info-item">
                    <i class="material-icons-round">check_circle</i>
                    <span>Supported Formats: XLS, XLSX</span>
                </div>
                <div class="info-item">
                    <i class="material-icons-round">check_circle</i>
                    <span>Max File Size: 15 MB</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
        <button type="button"
            class="btn-submit"
            [disabled]="isSubmitting"
            (click)="submitSupplier()">
            <span *ngIf="!isSubmitting">{{ mode === 'add' ? 'Submit' : 'Update' }}</span>
            <span *ngIf="isSubmitting">{{ mode === 'add' ? 'Submitting...' : 'Updating...' }}</span>
        </button>
    </div>
</div>